module.exports = __webpack_public_path__ + "img/logo_alcaldia.3664b7d5.svg";